<template>
  <div class="wrapper-content">
    <LmComponentLoading v-if="isLoading" fixed />
    <h1>Secretarias - Secretarios</h1>
    <p>Indique el secretario a cargo de la secretaría</p>
    <LmForm ref="lmFormRef">
      <div class="row">
        <div class="col-6">
          <LmSuperPowerSelect
              :tbColumns="lmSuperPowerSelects.secretaria.tbColumns"
              :label="$t('Secretaría')"
              :placeholder="$t('secretaria')"
              :model="sanitizeModel(form.secretaria)"
              :disabled="isOnEditMode"
              :data="lmSuperPowerSelects.secretaria.selectOptions"
              @values="inputSecretaria"
              />
        </div>
        <div class="col-6">
          <LmSuperPowerSelect
              :tbColumns="lmSuperPowerSelects.secretario.tbColumns"
              :label="$t('Secretario')"
              :placeholder="$t('secretario')"
              :model="sanitizeModel(form.secretario)"
              :data="lmSuperPowerSelects.secretario.selectOptions"
              @values="inputSecretario"
              :v="$v.form.secretario"
              />
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <LmTextInput
            v-model="form.emailSecretaria"
            label="Email Secretaría - Si es más de uno, debe cargarlos separarlos con ;"
            />
        </div>
      </div>
      <hr class="w-100">
      <div>
        <div class="row">
          <LmButton
            id="btn-cancel"
            type="button"
            class="ml-3"
            buttonClass="btn-secondary"
            :value="$t('Cancel')"
            @click.native="cancelBtn"
          />
          <LmButton
            :value="$t('save')"
            class="ml-2"
            buttonClass="btn-primary"
            @click="onSave"
          />
        </div>
      </div>
    </LmForm>
  </div>
</template>

<script>
import LmProfileCropper from '@/components/LmProfileCropper.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmColorPicker from '@/components/form/elements/LmColorPicker'
import LmUploadFiles from '@/components/form/elements/LmUploadFiles'
import LmButton from '@/components/form/elements/LmButton'
import LmEditor from '@/components/form/elements/lmEditor'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect.vue'
import LmForm from '@/components/form/LmForm.vue'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import _ from 'lodash'
// import axios from 'axios'
import { required } from 'vuelidate/lib/validators'

import { mapActions } from 'vuex'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmSuperPowerSelectHelper, lmToasts],
  components: {
    LmTreeSelect,
    LmSuperPowerSelect,
    lmSuperPowerSelectHelper,
    LmTextInput,
    LmColorPicker,
    LmUploadFiles,
    LmButton,
    LmProfileCropper,
    LmEditor,
    LmForm,
    LmEmailInput
  },
  data () {
    return {
      isLoading: false,
      secretaria: [],
      secretario: [],
      emailSecretaria: '',
      secretarioNombre: '',
      lmSuperPowerSelects: {
        secretaria: {
          selectOptions: [],
          tbColumns: [
            { title: 'Secretaria', data: 'name' }
          ]
        },
        secretario: {
          selectOptions: [],
          tbColumns: [
            { title: 'Secretario', data: 'name' }
          ]
        }
      },
      form: {
        secretaria: [],
        secretario: [],
        emailSecretaria: ''
      }
    }
  },
  validations () {
    return {
      form: {
        secretario: {
          required
        },
        emailSecretaria: {
          required
        }
      }
    }
  },
  computed: {

  },
  props: {
    title: {
      type: String,
      required: true
    },
    editEndpointUri: {
      type: String,
      required: true
    },
    isOnEditMode: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    /*
    async onSave () {
      try {
        this.isLoading = true
        // await commonsApi.axiosPutWrapper('/decretossettings/update', this.settings)
        let saveData = {
        }
        try {
          await this.updateItemDetail({
            path: 'decretossettings/secretarios_secretarias/secretarias_update/',
            data: saveData
          })
        } finally {
          this.isLoading = false
        }
        this.lmToastSuccessMessage('Se guardaron los cambios.', 'Se guardó exitosamente')
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    */

    inputSecretaria (value) {
      if (value.length) {
        this.form.secretaria = value[0].id
      } else {
        this.form.secretaria = ''
      }
      /*
      let secretaria = []
      _.forEach(e, (value) => {
        secretaria.push({ id: `${value.id}` })
      })
      this.form.secretaria = secretaria
      */
    },

    inputSecretario (value) {
      if (value.length) {
        this.form.secretario = value[0].id
        this.form.secretarioNombre = value[0].name
      } else {
        this.form.secretario = ''
        this.form.secretarioNombre = ''
      }
      /*
      let secretario = []
      _.forEach(e, (value) => {
        secretario.push({ id: `${value.id}` })
      })
      this.form.secretario = secretario
      */
    },

    async setForm () {
      let datos
      this.isLoading = true
      if (this.isOnEditMode) {
        // console.log('this.$route.params.id: ', this.$route.params.id)
        // console.log('this.$refs: ', this.$refs)
        /*
        datos = await this.$refs.lmFormRef.activeEditMode({
          path: 'decretossettings/secretarios_secretarias/detail/',
          id: this.$route.params.id
        })
        */
        datos = await commonsApi.getItemDetail({
          path: 'decretossettings/secretarios_secretarias/detail/',
          id: this.$route.params.id
        })
          .catch(error => {
            console.log(error)
            return {
              total: 0,
              items: []
            }
          })
        if (datos.secretariaId.idSecretaria?.length) {
          this.form.secretaria = datos.secretariaId.idSecretaria[0]
        }
        if (datos.secretarioLegajo.idSecretario?.length) {
          this.form.secretario = datos.secretarioLegajo.idSecretario[0]
        }
        // console.log('MAils: ', datos.cadenaEmails)
        this.form.emailSecretaria = datos.cadenaEmails
      } else {
        this.$nextTick(function () {
          this.secretaria = []
          this.secretario = []
          this.emailSecretaria = ''
        })
        this.form = JSON.parse(this.initialForm)
      }
      try {
        const response = await this.getAllLmSuperPowerSelectOptions(
          [
            { name: 'secretaria',
              obj: {
                path: 'oficinas/secretarias/',
                total: 2000
              }
            },
            { name: 'secretario',
              obj: {
                path: 'usuarios/todos/',
                total: 2000
              }
            }
          ])

        for (const e of response) {
          this.lmSuperPowerSelects[e.name].selectOptions = e.data
        }

        if (this.isOnEditMode) {
          // Secretaria
          let secretaria = []

          _.forEach(this.lmSuperPowerSelects['secretaria'].selectOptions, function (value, key) {
            secretaria.push({ id: value })
          })
          this.secretaria = secretaria
          // Secretario
          let secretario = []
          _.forEach(this.lmSuperPowerSelects['secretario'].selectOptions, function (value, key) {
            secretario.push({ id: value })
          })
          this.secretario = secretario
          this.emailSecretaria = this.cadenaEmails
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log('error', error)
      }
    },

    /*
    updateSecretaria (values) {
      this.form.secretaria = values.map(i => {
        return {
          id: i.id
        }
      })
    },

    updateSecretario (values) {
      console.log(values)
      this.form.secretario = values.map(i => {
        return {
          id: i.id
        }
      })
    },
    */
    cancelBtn () {
      this.$router.push('/decretossettings/secretarios_secretarias')
    },
    sanitizeModel (model) {
      return model ? model.toString() : ''
    },
    async onSave (accionLuegoDeGuardar = '') {
      try {
        let idSecretariaSecretario = false
        this.isLoading = true
        if (this.isOnEditMode) {
          await this.$refs.lmFormRef.validationForm(this.$v)
          this.formIsProcessing = true
          /**
           * Se persisten los datos
           */
          let saveData = {
            id: parseInt(this.$route.params.id),
            secretaria: this.form.secretaria.toString(),
            secretario: this.form.secretario.toString(),
            secretarioNombre: this.form.secretarioNombre,
            emailSecretaria: this.form.emailSecretaria
          }
          // console.log('saveData: ', saveData)
          try {
            let response = await this.updateItemDetail({
              path: 'decretossettings/secretarios_secretarias/secretarias_update/',
              data: saveData
            })
            if (response.id) {
              idSecretariaSecretario = response.id
            }
          } finally {
            this.formIsProcessing = false
          }
        } else {
          await this.$refs.lmFormRef.validationForm(this.$v)
          this.formIsProcessing = true
          /**
           * Se persisten los datos
           */
          let saveData = {
            secretaria: this.form.secretaria,
            secretario: this.form.secretario,
            secretarioNombre: this.form.secretarioNombre,
            emailSecretaria: this.form.emailSecretaria
          }
          console.log('saveData: ', saveData)
          try {
            let response = await this.updateItemDetail({
              path: 'decretossettings/secretarios_secretarias/secretarias_new/',
              data: saveData
            })
            if (response.id) {
              idSecretariaSecretario = response.id
            }
          } finally {
            this.formIsProcessing = false
          }
        }

        try {
          this.formIsProcessing = true
          this.formIsProcessing = false
          if (idSecretariaSecretario) {
            let mensaje = ''
            if (this.isOnEditMode) {
              mensaje = 'Relación Actualizada'
            } else {
              mensaje = 'Nuevo Relación Guardada'
            }
            this.lmToastSuccessInternalLink(`/decretossettings/secretarias_detail/edit/${idSecretariaSecretario}`, 'Ver Detalle', mensaje)
            this.$router.push('/decretossettings/secretarios_secretarias')
          }
        } finally {
          this.formIsProcessing = false
          this.isLoading = false
        }
      } catch (error) {
        this.isLoading = false
        console.log(error)
      }
    }
  },
  mounted () {
    this.setForm()
  }
}
</script>
<style lang="sass" scoped>

</style>
